import { z } from "zod";

/**
 * ImageNodeSchema - Content Schema for Image Media Node
 *
 * Image nodes represent embedded images with metadata.
 *
 * Field naming convention:
 * - src: Image URL or base64 data
 * - altText: Alt text for accessibility (optional)
 * - width: Display width in pixels (optional)
 * - height: Display height in pixels (optional)
 */
export const ImageNodeSchema = z.object({
  // Protocol metadata
  type: z.literal("image"),
  version: z.literal(1),
  key: z.string(),

  // Business data
  src: z.string().min(1),
  altText: z.string().optional(),
  width: z.number().positive().optional(),
  height: z.number().positive().optional(),
}).strict();

export type ImageNode = z.infer<typeof ImageNodeSchema>;
